import { get as o } from "theme-ui";
import { keyframes as e } from "@emotion/react";
const i = e({
  "0%": { opacity: 1 },
  "100%": { opacity: 0 }
}), a = e({
  "100%": { opacity: 1 },
  "0%": { opacity: 0 }
}), n = {
  bg: "primary",
  borderRadius: "md",
  color: "white",
  maxWidth: [null, "480px"],
  minWidth: [null, "340px"],
  width: ["95%", "auto"],
  py: 2,
  px: 3,
  "@media (prefers-reduced-motion: no-preference)": {
    '&[data-state="open"]': (t) => ({
      animation: `${a} ${o(t, "transitions.default")}`
    }),
    '&[data-state="closed"]': (t) => ({
      animation: `${i} ${o(t, "transitions.default")}`
    })
  }
}, s = {
  position: "fixed",
  bottom: 0,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,
  m: 0,
  width: ["100vw", "auto"],
  listStyle: "none",
  zIndex: "toastViewport",
  outline: "none",
  "&:not(:empty)": {
    p: 2
  }
}, m = {
  toast: n,
  toastViewport: s
};
export {
  m as toastsTheme
};
